<div class="container">
  <img class="logo" src="/assets/images/login-logo.png">

  <div class="content-wrapper" #wrapper>

    <div class="title">Admin Portal Log In</div>
    <div class="sub-title">Manage suppliers, applications, and more with the Admin Portal.</div>

    <asl-google-signin-button type="standard" [size]="buttonSize" [width]="buttonWidth"></asl-google-signin-button>
  </div>
</div>